<template>
    <div class="content">
        <div class="search_wrapper">
            <div class="search_head">
                <span>查询条件</span>
                <i class="searchDomw" @click="isSearchContent = !isSearchContent" :class="isSearchContent == true ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                <!-- <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="clearData"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button> -->
            </div>
            <div class="search_content"  v-show="isSearchContent">
                <div class="search_inline">
                    <el-form label-width="90px">
                        <el-row>
                            <el-col :span="5">
                                <el-form-item label="姓名">
                                    <el-input
                                        v-model="customerName"
                                        placeholder="姓名"
                                    ></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="5" :offset="1">
                                <el-form-item label="取餐方式">
                                    <el-select
                                        v-model="takeWay"
                                        placeholder="请选择取餐方式"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="item in takeList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" :offset="2">
                                <el-button
                                    type="primary"
                                    icon="el-icon-search"
                                    class="searchBtns"
                                    @click="searchData"
                                    >搜索</el-button
                                >
                                <el-button
                                    type="info"
                                    icon="el-icon-delete"
                                    @click="clearData"
                                    >清除条件</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div> -->
            </div>
        </div>
        <div class="table_title">
            <div class="btn_group">
                <el-button-group>
                    <el-button
                        type="success"
                        icon="iconfont icon-xinzeng"
                        class="openBtns"
                        @click="handleTableForm('新增', 'add')"
                        >新增</el-button
                    >
                </el-button-group>
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="clearData"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                        <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox label="序号"
                                            >序号</el-checkbox
                                        ><br />
                                        <el-checkbox label="姓名"
                                            >姓名</el-checkbox
                                        ><br />
                                        <el-checkbox label="餐补类型"
                                            >餐补类型</el-checkbox
                                        ><br />
                                        <el-checkbox label="订餐方式"
                                            >订餐方式</el-checkbox
                                        ><br />
                                        <el-checkbox label="取餐方式"
                                            >取餐方式</el-checkbox
                                        ><br />
                                        <el-checkbox label="余额"
                                            >余额</el-checkbox
                                        ><br />
                                        <el-checkbox label="剩余就餐次数"
                                            >剩余就餐次数</el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"
                                            >操作</el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- tableb表格 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    show-overflow-tooltip
                >
                    <template scope="scope">
                        <span
                            >{{
                                scope.$index +
                                (pageOne.pageNo - 1) * pageOne.pageSize +
                                1
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="customerName"
                    label="姓名"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '姓名'
                        ) != -1
                    "
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="gradeName"
                    label="餐补类型"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '餐补类型'
                        ) != -1
                    "
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="orderWay"
                    label="订餐方式"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '订餐方式'
                        ) != -1
                    "
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.orderWay == '0'">按月</span>
                        <span v-if="scope.row.orderWay == '1'">按次</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="takeWay"
                    label="取餐方式"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '取餐方式'
                        ) != -1
                    "
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.takeWay == 0">送餐</span>
                        <span v-if="scope.row.takeWay == 1">堂食</span>
                        <span v-if="scope.row.takeWay == 2">自取</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="orderBalance"
                    label="余额"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '余额'
                        ) != -1
                    "
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="onlyTimes"
                    label="剩余就餐次数"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '剩余就餐次数'
                        ) != -1
                    "
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span @click="showDialog(scope.row)">
                            {{ scope.row.onlyTimes }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="operation"
                    label="操作"
                    align="center"
                    width="250px"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <span
                            @click="handleTableForm('查看', scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >查看</span
                        >
                        <span
                            @click="handleTableForm('编辑', scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >编辑</span
                        >
                        <span
                            @click="seeOrder(scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >订餐记录</span
                        >
                        <span
                            @click="deleteItem(scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >删除</span
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-size="pageOne.pageSize"
                :current-page.sync="pageOne.pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageOne.total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <food-open
            v-if="formVisible"
            :openData="formInfo"
            @cancleOpen="cancleOpen"
        ></food-open>
        <open-info
            v-if="orderVisible"
            :openData="orderInfo"
            @cancleOpen="cancleOrder"
        ></open-info>
        <dc-record
            :title="'就餐记录'"
            :show="dc_record_state"
            :datas="dc_records_data"
        >
        </dc-record>
    </div>
</template>
<script>
import foodOpen from "./components/foodOpen"
import { work_dc_records } from "@/api/api.js"
import openInfo from "./components/openInfo"
import dcRecords from "./components/dcRecord"
export default {
    props: ["personData"],
    components: { foodOpen, openInfo, "dc-record": dcRecords },
    data() {
        return {
            takeList: [
                { value: "0", label: "送餐" },
                { value: "1", label: "堂食" },
                { value: "2", label: "自取" },
            ],
            dc_records_data: {},
            dc_record_state: false,
            customerName: "",
            formVisible: false,
            formInfo: {},
            orderVisible: false,
            orderInfo: {},
            takeWay: "",
            isSearchContent: false,
            pageOne: { pageSize: 10, pageNo: 1, total: 0 },
            tableData: [],
            dialogVisible: false, //人员编辑
            dialogInfo: {},
            personState: false, //新增人员
            personInfo: {},
            radioId: "",
            tempTableChekbox: [
                "序号",
                "姓名",
                "餐补类型",
                "订餐方式",
                "取餐方式",
                "余额",
                "剩余就餐次数",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "姓名",
                "餐补类型",
                "订餐方式",
                "取餐方式",
                "余额",
                "剩余就餐次数",
                "操作",
            ],
        }
    },
    created() {
        this.getList()
    },
    watch: {
        personData(old, news) {
            this.getList()
        },
    },
    methods: {
        dc_records_close() {
            this.dc_record_state = false
            this.dc_records_data = { table: [] }
        },
        refresh() {
            this.formVisible = false
            this.formInfo.state = false
            this.getList()
        },
        // 取消查看记录
        cancleOrder() {
            this.orderVisible = false
            this.dialogVisible = false
            this.orderInfo = {}
        },
        // 查看记录
        seeOrder(row) {
            console.log(row)
            let { customerId, id } = row
            this.dc_record_state = true
            work_dc_records({
                customerId,
                orderId: id,
                communityId: this.personData,
            }).then(({ content }) => {
                if (content) {
                    this.dc_records_data = { table: content }
                } else {
                    this.dc_records_data = { table: [] }
                }
            })
        },
        // 搜索
        searchData() {
            this.getList()
        },
        // 关闭人员信息弹窗
        cancleOpen() {
            this.dialogInfo = {}
            this.dialogVisible = false
            this.orderVisible = false
            // this.tableData = [];
            this.getList()
        },
        //删除表格信息
        deleteItem(data) {
            let { id, personId, communityId, customerId } = data
            let params = {
                id,
                personId,
                communityId,
                customerId,
            }

            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/ypt/admin/order/deleteById",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success("删除成功")
                            // this.tableData = [];
                            this.getList()
                        }
                    })
            })
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //重置
        clearData() {
            this.customerName = ""
            this.takeWay = ""
            this.pageOne.pageSize = 10
            this.pageOne.pageNo = 1
            this.getList()
        },
        // 获取数据
        getList() {
            let { takeWay, customerName } = this
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                socialOrgId: this.personData,
                customerName,
                takeWay,
                communityId: this.personData,
            }
            this.$http
                .request({
                    url: "/ypt/admin/order/selectByCondition",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },
        // 操作方法
        handleTableForm(title, row) {
            this.formInfo = {
                title: title,
                id: row != "add" ? row.id : "",
                state: true,
                socialOrgId: this.personData,
                customerId: row.customerId,
            }
            this.formVisible = true
        },
        cancleOpen() {
            this.formVisible = false
            this.orderVisible = false
            this.formInfo = {}
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.btn_group {
    margin-top: 0px !important;
}
/deep/.table_title {
    margin-top: 10px !important;
}

/deep/ .search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #F1F2F6;
  box-shadow:  0 0 6px rgba(100, 100, 100, 0.16);
  overflow: hidden;
  border-radius: 4px;
  .search_head {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .search_content {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    // display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .search_inline {
    width: 100%;
  }
  .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
}
.searchDomw{cursor: pointer;}
</style>